export default __webpack_public_path__ + "static/media/logo.f4ca64dc.svg";